import React from 'react';
import { SwitchOffIcon, SwitchOnIcon } from 'assets/icons';
import { useMutation } from '@apollo/client';
import {
  ACTIVATE_KIOSK,
  DEACTIVATE_KIOSK
} from 'graphql/service';
import { Container } from './styles';
import { debouncedErrorMessage } from 'utils/messageUtil';

const Slider = ({
  kioskId,
  checked,
  setKiosks,
  left
}) => {

  const [activateKiosk] = useMutation(ACTIVATE_KIOSK,
    {
      onCompleted: (data) => {
        setKiosks(prevKiosks => {
          return prevKiosks.map(kiosk => {
            if(kiosk.id === kioskId) {
              return {
                ...kiosk,
                isDeleted: false
              }
            }
            return kiosk;
          });
        });
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    }
  );

  const [deactivateKiosk] = useMutation(DEACTIVATE_KIOSK,
    {
      onCompleted: (data) => {
        setKiosks(prevKiosks => {
          return prevKiosks.map(kiosk => {
            if(kiosk.id === kioskId) {
              return {
                ...kiosk,
                isDeleted: true
              }
            }
            return kiosk;
          });
        });
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    }
  );

  const handleToggle = () => {
    if(checked) {
      deactivateKiosk({
        variables: { 
          kioskId: kioskId
        }
      });
    } else {
      activateKiosk({
        variables: { 
          kioskId: kioskId
        }
      });
    }
  }

  return (
    <Container
      left={left}
    >
      <div
        className={`switch ${checked? 'active': ''}`}
        onClick={handleToggle}
      >
        <div className={`switchSlider ${checked? 'active': ''}`}>
          {checked? <SwitchOnIcon />: <SwitchOffIcon />}
        </div>
      </div>
      <div className={`switchText ${checked? 'active': ''}`}>
        {checked? 'ON': 'OFF'}
      </div>
    </Container>
  );
}

export default Slider;
